<template>
  <main style="height: 100vh;">
    <div class="heading">
      <img :src="login_logo" class="logo" />
    </div>
    <div class="loginform" :style="{ transform: `translateY(${offset}px)` }">
      <md-field>
        <div style="padding-bottom: 10px">
          <input-validate
            class="pp-input"
            type="text"
            name="phone"
            v-model="phone"
            placeholder="Enter phone number"
            v-validate="'phone'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            @focus="onFocus"
            @blur="onBlur"
            :error="errors.first('phone')"
          >
            <img class="phone-img" src="/static/icon/phone.png" slot="left" />
          </input-validate>
        </div>
        <div>
          <input-validate
            class="pp-input"
            type="password"
            name="password"
            v-model="password"
            placeholder="Enter password"
            v-validate="'password'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            @focus="onFocus"
            @blur="onBlur"
            :error="errors.first('password')"
          >
            <img
              class="password-img"
              src="/static/icon/password.png"
              slot="left"
            />
          </input-validate>
          <p class="forgotpassword" @click="go_forgotpassword">
            Forgot password
          </p>
        </div>
      </md-field>
    </div>
    <div class="loginbtn">
      <md-button class="primary" @click="loginClick" :loading="loading"
        >Login</md-button
      >
    </div>

    <md-agree
      class="agree"
      v-model="agreeConf.checked"
      :disabled="agreeConf.disabled"
      :size="agreeConf.size"
      @change="onChange(agreeConf.name, agreeConf.checked, $event)"
    >
      Agree <a href="/static/privacypolicy.html">"User Privacy Agreement"</a>
    </md-agree>
  </main>
</template>

<script>
import { Toast } from "mand-mobile";
import { login } from "@/request/api";
import inputValidate from "@/components/input-validate";
import { Validator } from "vee-validate";
import iconimg from "@/components/iconimg";

Validator.extend("phone", {
  getMessage: field => `${field} value do not meet right format`,
  validate: value => /^\d{10}$/.test(value)
});

Validator.extend("password", {
  getMessage: field => `${field} at least 6 digits`,
  validate: value => /^\S{6,}$/.test(value)
});

export default {
  name: "Login",
  components: {
    inputValidate
  },
  data() {
    return {
      phone: "",
      password: "",
      loading: false,
      ip: "127.0.0.1",
      iconimg,
      agreeConf: {
        checked: true,
        name: "agree0",
        size: "lg",
        disabled: false,
        introduction: "选中状态"
      },
      icon: [
        { name: 0, lable: "phone", icon: "phone" },
        { name: 1, lable: "password", icon: "password" }
      ],
      login_logo: ""
    };
  },
  created() {
    this.loading = false;
    this.login_logo = process.env.VUE_APP_LOGIN_LOGO;
    fetch("https://ipapi.tooripaindia.workers.dev/")
      .then(response => response.json())
      .then(data => {
        this.ip = data.ip;
      });
  },
  methods: {
    onFocus() {
      // 在获取焦点时判断是否被遮挡
      this.checkAndAdjustOffset();
    },

    onBlur() {
      // 失去焦点时还原表单
      this.offset = 0;
    },

    checkAndAdjustOffset() {
      // 获取输入框的位置
      const inputRect = this.$refs.phone.getBoundingClientRect();
      // 计算输入框底部距离屏幕底部的距离
      const distanceToBottom = window.innerHeight - inputRect.bottom;

      // 如果被遮挡，则上移表单
      if (distanceToBottom < 0) {
        this.offset = distanceToBottom;
      } else {
        this.offset = 0;
      }
    },

    onChange(name, checked) {
      console.log(
        `agree name = ${name} is ${checked ? "checked" : "unchecked"}`
      );
    },
    loginClick() {
      let that = this;
      if (!this.agreeConf.checked) {
        this.$toast.failed('Please read the "User Privacy Agreement" first');
        return;
      }
      that.loading = true;
      const success = this.$validator.validateAll().then(res => {
        if (res) {
          login({
            phone: that.phone,
            password: that.password,
            ip: this.ip
          })
            .then(res => {
              that.loading = false;
              if (res.code === 200) {
                // login success
                Toast.succeed("successful login");
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("phone", that.phone);
                that.$store.dispatch("asyncupdateuserinfo").then(data => {
                  if (data.username.indexOf("gtest") != -1) {
                    window.location.href = "./home.html";
                  } else {
                    setTimeout(() => {
                      that.$router.push("home");
                    }, 1200);
                  }
                });
              } else {
                Toast.failed(res.errmsg);
              }
            })
            .catch(error => {
              that.loading = false;
              Toast.failed("Network Error!");
              console.log("Network Error: ", error);
            });
        } else {
          this.loading = false;
          return;
        }
      });
    },
    go_forgotpassword() {
      this.$router.push("/editpassword");
    }
  }
};
</script>

<style scoped>
.phone-img {
  width: 0.5rem;
  height: 0.5rem;
}

.password-img {
  width: 0.5rem;
  height: 0.5rem;
}

.pp-input {
  border: 1px solid #f8fbff;
  border-radius: 1.2rem;
  padding-left: 0.3rem;
  margin: 0.1rem;
  background-color: #f8fbff;
}

.agree {
  font-size: 0.2rem;
  margin-left: auto;
  margin-right: auto;
  padding-top: 1rem;
  width: 50%;
  padding: 0 auto;
  color: #007aff;
}

.forgotpassword {
  float: right;
  font-size: 30px;
  color: #007aff;
  padding-top: 2px;
}

.logo {
  width: 100%;
}

.heading {
  text-align: center;
}

.heading h1 {
  color: #333;
  line-height: 1.15;
  font-size: 64px;
  margin-bottom: 32px;
}

.heading h1 span {
  position: relative;
}

.heading h1 span::after {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 8px;
  width: 100%;
  height: 20px;
  background: #ecf6ff;
}

.loginform {
  width: 100%;
  height: 0.75rem;
  transition: transform 0.3s ease; /* 添加过渡效果，使上移和还原更平滑 */
}

.loginbtn {
  margin-top: 3rem;
  padding: 10px 40px 0 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue